<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard>
        <CCardHeader>
          <CCol>
            <strong>Candidate Details</strong>
            <back-to-list></back-to-list>
          </CCol>
        </CCardHeader>
        <CCardBody>
          <CTabs add-tab-classes="mt-1">
            <span @click="selected = 'Details'" v-if="checkPermission('list-candidate')">
              <CTab active>
                <template slot="title">
                  {{ $lang.recruitments.tab.details }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'CandidateMedia'" v-if="checkPermission('list-candidate')">
              <CTab>
                <template slot="title">
                  {{ $lang.candidates.tab.media }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'CandidateResponse'" v-if="checkPermission('view-list-candidate-response')">
              <CTab>
                <template slot="title">
                  {{ $lang.candidates.tab.response }}
                </template>
              </CTab>
            </span>
            <span @click="selected = 'CandidateReport'" v-if="checkPermission('view-list-candidate-report')">
              <CTab>
                <template slot="title">
                  {{ $lang.candidates.tab.report }}
                </template>
              </CTab>
            </span>
          </CTabs>
          <component :is="selected" style="margin-top: 20px" v-bind:recruitmentId="currentId"
                     v-bind:profileId="profileId" @changeSelected="getTab($event)"></component>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import {Mixin} from "/src/mixins/index.js";
import CandidateMedia from "./tab/CandidateMedia";
import CandidateReport from "./tab/CandidateReport";
import CandidateResponse from "./tab/CandidateResponse";
import Details from "./tab/Details";
import BackToList from "../backToList.vue";

export default {
  name: "CandidateView",
  mixins: [Mixin],
  components: {
    Details,
    CandidateMedia,
    CandidateReport,
    CandidateResponse,
    BackToList,
  },
  data() {
    return {
      userId: "",
      selected: "Details",
      currentId: "",
      profileId: "",
    };
  },
  methods: {
    backToList(userId) {
      if (userId != null) {
        this.$router.push({path: "/profile/all/" + userId});
      }
    },
    getTab(tab) {
      let self = this;
      self.selected = tab;
    },
  },
};
</script>
<style>
div .error {
  color: #ff0000;
}

.hasError label {
  color: red;
}
</style>
